export default __webpack_public_path__ + "static/media/token-old.4bea10fa.png";